export default __webpack_public_path__ + "static/media/Vijayavani3.cf0c940d.png";